/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslation } from "react-i18next";
import { TableSearch } from "../../common/svg/AllSvg";
import { useEffect, useState } from "react";

const Banner = ({ searchList, setData, search, setSearch }: any) => {
    const { t } = useTranslation('common');
    const [focus, setFocus] = useState<boolean>(false);

    const handleSearch = () => {
        let arr: any[] = searchList;
        if (!!search) {
            // eslint-disable-next-line 
            arr = arr.filter((item: any) => {
                if (item?.name?.toLowerCase()?.includes(search?.toLowerCase())) {
                    return true;
                }
            });
        } else {
            arr = searchList;
        }

        setData(arr);
    }

    useEffect(() => {
        handleSearch();
    }, [search])

    return (
        <div className="px-[18px] xlsm:px-[25px] xlx:px-[45px] flex items-center justify-center">
            <div className="w-[1200px] xlx:w-[1384px] h-full grid grid-cols-1 msm:grid-cols-3 items-center xl:flex pt-[30px] msm:pt-[50px] xlx:pt-[65px] gap-[30px] xlx:gap-[50px]">
                <div className="w-full flex items-center justify-center">
                    <img src={require("../../../assets/images/tour1.png")} alt="banner-img" />
                </div>
                <div className="flex items-center justify-center flex-col xl:min-w-[460px] xlx:min-w-[523px] xl:w-fit">
                    <h1 className="text-secPurple font-bold text-center">{t("passenger.tours.title")}</h1>
                    <h6 className="text-blackDull dark:text-textBlackDull font-medium text-center mt-[2px]">{t("passenger.tours.desc")}</h6>
                    <div className={`mt-[20px] border border-[#D7D8DD] dark:border-[#454545] h-[38px] xsm:h-[40px] px-[15px] xlx:px-[17px] flex items-center gap-[8px] xlx:gap-[12px] rounded-full w-full xs:w-[360px] xsm:w-[400px] msm:w-full xl:w-[400px] xlx:w-[410px] ${focus ? "bg-white dark:bg-bgDarkDull" : "bg-[#F5F5F5] hover:bg-white dark:bg-bgDark dark:hover:bg-bgDarkDull"}`}>
                        <TableSearch className="xlx:w-[18px] xlx:min-w-[18px] xlx:h-[18px] min-w-[15px] w-[15px] h-[15px] fill-primary" />

                        <input type="text" className="text-opacity-[0.7] text-blackDull dark:text-textBlackDull placeholder:dark:text-textBlackDull font-medium placeholder:text-blackDull placeholder:text-opacity-[0.7] text-sm leading-tight placeholder:leading-tight w-full bg-transparent" placeholder={t("passenger.tours.search")} autoComplete="off" onFocus={() => setFocus(true)} onBlur={() => setFocus(false)} onChange={(e: any) => setSearch(e.target.value)} value={search} />
                    </div>
                </div>
                <div className="w-full flex items-center justify-center">
                    <img src={require("../../../assets/images/tour2.png")} alt="banner-img" />
                </div>
            </div>
        </div>
    );
};

export default Banner;